import React from "react";
import { Box, Heading } from "@chakra-ui/react";

export default function Logo(props) {
  return <Heading variant="logo">DevOps</Heading>;
}
